import { create } from 'superstruct';

import { get } from '~services/api/methods';
import { SvgValidator } from '../validators/Svg';

export async function fetchIconSvg(url: string) {
  const response = await get<ApiIconSvgResponse>(url, {
    withCredentials: true,
  });
  return create(response, SvgValidator);
}
